import { Notify } from "@flexisaf/flexibull2";
import { call, put, takeLatest } from "redux-saga/effects";
import { examDelete } from "../../../services/exam";

import {
  deleteExamStart,
  deleteExamSuccess,
  deleteExamFailure,
} from "../reducer";

export function* deleteExam({ payload }) {
  const { id, callback } = payload;

  const response = yield call(examDelete, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteExamSuccess());
    Notify("Exam deleted successfully", { status: "success" });
    if (callback) {
      callback();
    }
  } else {
    yield put(deleteExamFailure(message || raw?.error));
    Notify(message || raw?.error, { status: "error" });
  }
}

export default function* onDeleteExam() {
  yield takeLatest(deleteExamStart.type, deleteExam);
}
